const getPriceWithoutDiscount = (price, discount) => Math.floor(price / (1 - discount  / 100))

export { getPriceWithoutDiscount }